import { Post } from './Post'
import { AuthorizedModInterface, AuthorizedUserInterface, InvitedUserInterface, User } from './User'
import { AuctionPublic } from './modes'

export interface AuctionBase {
  deposit: number
  startingDate: Date
  deadline: Date
  minPrice: number
  public: boolean | string | number | AuctionPublic | any
  attachment?: boolean
  totalRounds: number
  status?: AuctionStatus
  roundNumber?: number
  currentRound?: number
  currentPrice?: number
  authorizedUsers?: AuthorizedUserInterface[]
  authorizedMods?: AuthorizedModInterface[] | string[]
  invitedUsers?: InvitedUserInterface[] | string[]
  postId?: string
  post?: Post
  allowBelowMin: boolean
  minIncreasePrice: number
  nextRoundUsers: number
  numberOfMembers: number
  startImmediately?: boolean
  [key: string]: any
  createdAt?: string
  updatedAt?: string
  deletedAt?: string

  solvencyAttachment?: Solvency[]
  winner: string
  bids?: BidsLive[]
}

export interface Auction extends AuctionBase {
  id: string
}

export enum AuctionModes {
  Public = 'Public',
  Private = 'Private',
}

export interface Solvency {
  id: string
  auctionId: string
  document: Document[]
  user?: User
  valid: number
}

export interface Valid {
  id: string
  validId: number
}

export interface BidsLive {
  id: number
  createdAt: Date | any
  bid: number
  email: string
  firstName: string
  lastName: string
  avatar: string
  avatarId: string
  gender: number
  deadline: any
}

export interface AuthorizeValues {
  token: string
  validateEmail: string
  auctionId: string
}

export interface Document {
  id: string
  documentUrl: string
  name: string
  description: string
  valid: boolean
  type: string
  size: number
}

export interface AddDocument {
  file: any
  auctionId: string
}

export enum AuctionStatus {
  Pending = 0,
  Ongoing = 1,
  Blocked = 2,
  Finished = 3,
  FirstWinsFinished = 4,
  Deleted = 5,
}
